/* =============================================
   ANBE Madrid - Size Drawer v7
   - Móvil/tablet (<1024px): drawer de tallas (igual que v5)
   - PC (>=1024px): tallas en cuadrados sobre el botón, sin drawer
   - v7: en móvil, con talla agotada marcada, el botón vuelve a abrir el drawer (no STOQ)
   ============================================= */
(function() {
  'use strict';

  const SOLDOUT_MESSAGE = 'Avísame';
  const SIZE_MESSAGES = {};
  // Solo PC: pantalla ancha + ratón (excluye iPad en horizontal)
  const DESKTOP_QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';
  const DESKTOP_ATC_TEXT = 'Añadir a la cesta';

  let drawerEl = null;
  let overlayEl = null;
  let currentForm = null;
  let currentSection = null;
  let skipIntercept = false; // bandera para evitar bucle
  let desktopPicked = null;  // talla elegida en PC

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function createDrawer() {
    if (document.getElementById('anbe-size-drawer')) return;

    overlayEl = document.createElement('div');
    overlayEl.id = 'anbe-size-overlay';
    overlayEl.addEventListener('click', closeDrawer);
    document.body.appendChild(overlayEl);

    drawerEl = document.createElement('div');
    drawerEl.id = 'anbe-size-drawer';
    drawerEl.innerHTML = `
      <div class="anbe-drawer__header">
        <span class="anbe-drawer__title">Selecciona tu talla</span>
        <button class="anbe-drawer__close" aria-label="Cerrar">&#10005;</button>
      </div>
      <div class="anbe-drawer__subtitle" id="anbe-drawer-subtitle"></div>
      <div class="anbe-drawer__sizes" id="anbe-drawer-sizes"></div>
      <div class="anbe-drawer__footer">
        <a class="anbe-drawer__guide" href="#">Ver guía de tallas</a>
      </div>
    `;
    document.body.appendChild(drawerEl);
    drawerEl.querySelector('.anbe-drawer__close').addEventListener('click', closeDrawer);
    drawerEl.querySelector('.anbe-drawer__guide').addEventListener('click', function(e) {
      e.preventDefault();
      closeDrawer();
      setTimeout(() => {
        const trigger = document.querySelector('.ccpops-trigger');
        if (trigger) trigger.click();
      }, 350);
    });
  }

  function updateSizeRecommendation() {
    const rec = document.getElementById('anbe-size-rec');
    const subtitle = document.getElementById('anbe-drawer-subtitle');
    if (!subtitle) return;
    if (rec && rec.dataset.message) {
      subtitle.textContent = rec.dataset.message;
      subtitle.style.display = 'block';
    } else {
      subtitle.style.display = 'none';
    }
  }

  function openDrawer(form, section) {
    currentForm = form;
    currentSection = section;
    populateSizes(section);
    updateSizeRecommendation();
    drawerEl.classList.add('is-open');
    overlayEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    overlayEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function populateSizes(section) {
    const container = document.getElementById('anbe-drawer-sizes');
    container.innerHTML = '';

    const nodes = section.querySelectorAll('.m-product-option--node[data-option-type="button"]');
    if (!nodes.length) return;

    nodes.forEach(node => {
      const value = node.dataset.value;
      const isSoldOut = node.classList.contains('m-product-option--node__soldout');
      const message = isSoldOut ? SOLDOUT_MESSAGE : (SIZE_MESSAGES[value] || '');

      const row = document.createElement('div');
      row.className = 'anbe-size-row' + (isSoldOut ? ' is-soldout' : '');
      row.innerHTML = `
        <span class="anbe-size-row__name">${value}</span>
        <span class="anbe-size-row__msg">${message}</span>
      `;

      if (!isSoldOut) {
        row.addEventListener('click', () => selectAndAdd(node));
      } else {
        row.addEventListener('click', () => handleSoldOut(value));
      }

      container.appendChild(row);
    });
  }

  function selectAndAdd(node) {
    const radio = node.querySelector('input[type="radio"]');
    const label = node.querySelector('label');

    // Mostrar selector nativo temporalmente
    const optionBtns = currentSection.querySelectorAll('.m-product-option--button, .m-product-option--label');
    optionBtns.forEach(el => el.style.cssText = 'position:absolute;opacity:0;pointer-events:none;height:0;overflow:hidden;');

    // Seleccionar variante
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (label) label.click();

    // Esperar a Alpine, cerrar drawer, luego disparar ATC sin interceptar
    setTimeout(() => {
      closeDrawer();

      setTimeout(() => {
        const atcBtn = currentForm.querySelector('button[name="add"]');
        if (atcBtn) {
          skipIntercept = true; // desactivar intercepción
          atcBtn.click();
          setTimeout(() => { skipIntercept = false; }, 500);
        }

        // Volver a ocultar selector nativo
        optionBtns.forEach(el => el.style.cssText = 'display:none!important;');
      }, 200);
    }, 150);
  }

  function handleSoldOut(value) {
    closeDrawer();

    setTimeout(() => {
      // Buscar el botón de STOQ para esa talla
      const section = document.querySelector('.m-main-product, .main-product');
      if (!section) return;

      // Seleccionar la variante agotada primero
      const node = section.querySelector(`.m-product-option--node[data-value="${value}"]`);
      if (node) {
        const radio = node.querySelector('input[type="radio"]');
        const label = node.querySelector('label');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (label) label.click();
      }

      // Esperar a que STOQ actualice y hacer click en su botón
      setTimeout(() => {
        const stoqBtn = document.querySelector('.restock-rocket-button-product');
        if (stoqBtn) {
          stoqBtn.click();
        }
      }, 300);
    }, 350);
  }

  function hideNativeSizes() {
    if (document.getElementById('anbe-hide-sizes')) return;
    const style = document.createElement('style');
    style.id = 'anbe-hide-sizes';
    style.textContent = `
      .m-product-option--button { display: none !important; }
      .main-product__block-variant-picker .m-product-option--label { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  /* =============================================
     SOLO PC: tallas en cuadrados sobre el botón
     ============================================= */

  function injectDesktopStyles() {
    if (document.getElementById('anbe-dsizes-css')) return;
    const style = document.createElement('style');
    style.id = 'anbe-dsizes-css';
    style.textContent = `
      .anbe-dsizes { display: none; }
      @media ${DESKTOP_QUERY} {
        .anbe-dsizes { display: block; margin: 26px 0 16px; text-align: center; }
        .anbe-dsizes__list { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; }
        .anbe-dsizes__item {
          position: relative; min-width: 44px; height: 44px; padding: 0 10px; margin: 0;
          border: 1px solid #dcdad5; border-radius: 0; background: transparent; color: #1a1a18;
          font-family: 'Jost', sans-serif; font-size: 11px; font-weight: 400;
          letter-spacing: 1.5px; text-transform: uppercase; line-height: 1;
          cursor: pointer; transition: border-color .2s ease, background-color .2s ease, color .2s ease;
        }
        .anbe-dsizes__item:hover { border-color: #1a1a18; }
        .anbe-dsizes__item.is-selected { background: #1a1a18; border-color: #1a1a18; color: #fff; }
        .anbe-dsizes__item.is-soldout { color: #b8b6b1; border-color: #ecebe7; }
        .anbe-dsizes__item.is-soldout::after {
          content: ''; position: absolute; left: 7px; right: 7px; top: 50%;
          border-top: 1px solid #d3d1cc; transform: rotate(-24deg);
        }
        .anbe-dsizes__item.is-soldout:hover { color: #1a1a18; border-color: #1a1a18; }
        .anbe-dsizes__hint:empty { display: none; }
        .anbe-dsizes__hint {
          margin-top: 12px;
          font-family: 'Jost', sans-serif; font-size: 10px; font-weight: 400;
          letter-spacing: 2px; text-transform: uppercase; color: #1a1a18; opacity: .6;
        }
        .anbe-dsizes.is-alert .anbe-dsizes__hint { opacity: 1; }
        .anbe-dsizes.is-alert .anbe-dsizes__list { animation: anbe-dsizes-shake .4s ease; }
        @keyframes anbe-dsizes-shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-4px); }
          75% { transform: translateX(4px); }
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getMainSection() {
    const picker = document.querySelector('.main-product__block-variant_picker');
    if (!picker) return null;
    return picker.closest('[data-section-id]') || picker.closest('.m-main-product') || document.querySelector('.main-product');
  }

  function getCheckedValue(section) {
    const checked = section.querySelector('.m-product-option--node[data-option-type="button"] input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function setHint(text) {
    const hint = document.querySelector('.anbe-dsizes__hint');
    if (hint) hint.textContent = text || '';
  }

  function defaultHint() {
    const rec = document.getElementById('anbe-size-rec');
    return rec && rec.dataset.message ? rec.dataset.message : '';
  }

  const ORIGINAL_ATC_TEXT = 'SELECCIONA TU TALLA';
  let atcObserver = null;

  function setAtcText(text) {
    document.querySelectorAll('form[action*="/cart/add"] .m-add-to-cart--text').forEach(el => {
      const wanted = text || ORIGINAL_ATC_TEXT;
      if (el.textContent.trim() !== wanted) el.textContent = wanted;
    });
  }

  // Si Minimog repinta el botón (cambio de variante, tras añadir...), mantenemos el texto correcto en PC
  function watchAtcText() {
    if (atcObserver) atcObserver.disconnect();
    atcObserver = new MutationObserver(() => {
      if (!isDesktop() || !desktopPicked) return;
      const btn = document.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (btn && btn.disabled) return; // variante agotada: respetar texto del tema
      setAtcText(DESKTOP_ATC_TEXT);
    });
    document.querySelectorAll('form[action*="/cart/add"] button[name="add"]').forEach(btn => {
      atcObserver.observe(btn, { childList: true, subtree: true, characterData: true });
    });
  }

  function selectNative(section, value) {
    const node = section.querySelector(`.m-product-option--node[data-option-type="button"][data-value="${value}"]`);
    if (!node) return;
    const radio = node.querySelector('input[type="radio"]');
    const label = node.querySelector('label');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (label) label.click();
  }

  function markSelected(value) {
    document.querySelectorAll('.anbe-dsizes__item').forEach(b => {
      const on = b.dataset.value === value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function buildDesktopSizes() {
    injectDesktopStyles();
    const section = getMainSection();
    if (!section) return;

    const nodes = section.querySelectorAll('.m-product-option--node[data-option-type="button"]');
    const buyBlock = section.querySelector('.main-product__block-buy_buttons');
    if (!nodes.length || !buyBlock) return;

    const old = section.querySelector('.anbe-dsizes');
    if (old) old.remove();
    desktopPicked = null;

    const wrap = document.createElement('div');
    wrap.className = 'anbe-dsizes';
    wrap.innerHTML = '<div class="anbe-dsizes__list" role="group" aria-label="Talla"></div><div class="anbe-dsizes__hint" aria-live="polite"></div>';
    const list = wrap.querySelector('.anbe-dsizes__list');

    nodes.forEach(node => {
      const value = node.dataset.value;
      const isSoldOut = node.classList.contains('m-product-option--node__soldout');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'anbe-dsizes__item' + (isSoldOut ? ' is-soldout' : '');
      btn.dataset.value = value;
      btn.textContent = value;
      btn.setAttribute('aria-pressed', 'false');
      if (isSoldOut) btn.setAttribute('aria-label', value + ' - agotada, avísame');

      btn.addEventListener('mouseenter', () => {
        if (isSoldOut) setHint(value + ' · Agotada — ' + SOLDOUT_MESSAGE);
      });
      btn.addEventListener('mouseleave', () => {
        if (isSoldOut && !wrap.classList.contains('is-alert')) setHint(defaultHint());
      });

      btn.addEventListener('click', () => {
        wrap.classList.remove('is-alert');
        if (isSoldOut) {
          desktopPicked = null;
          markSelected(null);
          handleSoldOut(value);
          return;
        }
        desktopPicked = value;
        markSelected(value);
        setHint(defaultHint());
        selectNative(section, value);
        // Minimog repinta el botón al cambiar de variante: esperamos y cambiamos el texto
        setTimeout(() => setAtcText(DESKTOP_ATC_TEXT), 250);
      });

      list.appendChild(btn);
    });

    buyBlock.insertBefore(wrap, buyBlock.firstChild);
    setHint(defaultHint());
    watchAtcText();
  }

  function alertDesktop() {
    const wrap = document.querySelector('.anbe-dsizes');
    if (!wrap) return;
    wrap.classList.remove('is-alert');
    void wrap.offsetWidth; // reiniciar animación
    wrap.classList.add('is-alert');
    setHint('Selecciona una talla');
    const rect = wrap.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /* =============================================
     SOLO MÓVIL/TABLET: si la variante marcada está agotada, el tema oculta
     el botón y STOQ pone "Avísame cuando esté disponible". Lo sustituimos
     por un botón "Selecciona tu talla" que vuelve a abrir el drawer.
     ============================================= */

  function injectMobileStyles() {
    if (document.getElementById('anbe-msize-css')) return;
    const style = document.createElement('style');
    style.id = 'anbe-msize-css';
    style.textContent = `
      .anbe-msize-btn { display: none; }
      @media not all and ${DESKTOP_QUERY} {
        form[action*="/cart/add"]:has(button[name="add"]:disabled) .anbe-msize-btn {
          display: flex !important; width: 100%; align-items: center; justify-content: center;
          opacity: 1; pointer-events: auto;
        }
        body:has(.anbe-msize-btn) .restock-rocket-button-product { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function buildMobileButton(form, section) {
    injectMobileStyles();
    if (form.querySelector('.anbe-msize-btn')) return;
    const atc = form.querySelector('button[name="add"]');
    if (!atc) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    // Mismo aspecto que el botón del tema, sin sus clases de comportamiento
    btn.className = atc.className
      .replace(/\b(disabled|m-add-to-cart|m-spinner-button)\b/g, '')
      .replace(/\s+/g, ' ').trim() + ' anbe-msize-btn';
    btn.innerHTML = '<span>' + ORIGINAL_ATC_TEXT + '</span>';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(form, section);
    });
    atc.insertAdjacentElement('afterend', btn);
  }

  function interceptATC() {
    hideNativeSizes();

    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const section = form.closest('[data-section-id]')
        || form.closest('.m-main-product')
        || document.querySelector('.main-product');
      if (!section) return;

      const hasSizes = section.querySelector('.m-product-option--node[data-option-type="button"]');
      if (!hasSizes) return;

      buildMobileButton(form, section);

      const btns = form.querySelectorAll('button[type="submit"], button[name="add"]');
      btns.forEach(btn => {
        if (btn.dataset.anbeOk) return;
        btn.dataset.anbeOk = '1';

        btn.addEventListener('click', function(e) {
          if (skipIntercept) return; // dejar pasar el click interno

          // PC: sin drawer. Si hay talla elegida, añadir; si no, avisar.
          if (isDesktop() && document.querySelector('.anbe-dsizes')) {
            const mainSection = getMainSection() || section;
            if (desktopPicked && getCheckedValue(mainSection) === desktopPicked) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            alertDesktop();
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();
          openDrawer(form, section);
        }, true);
      });
    });
  }

  function init() {
    createDrawer();
    buildDesktopSizes();
    interceptATC();
    document.addEventListener('shopify:section:load', () => setTimeout(() => {
      buildDesktopSizes();
      interceptATC();
    }, 400));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
